"use client";

import { Button } from "@/components/shadcn/button";
import { Input } from "@/components/shadcn/input";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/shadcn/popover";
import { useRouter } from "@/i18n/navigation";
import { ArrowRight, Search } from "lucide-react";
import { useTranslations } from "next-intl";
import { FormEvent, useState } from "react";

export function NavbarSearch() {
    const router = useRouter();
    const t = useTranslations("nav");
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const normalizedQuery = query.trim();
        if (!normalizedQuery) return;

        setOpen(false);
        router.push(`/arama?q=${encodeURIComponent(normalizedQuery)}`);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button variant="ghost" size="icon" aria-label={t("search")}>
                    <Search />
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-80">
                <form onSubmit={handleSubmit} className="flex gap-2">
                    <Input
                        type="search"
                        value={query}
                        onChange={(event) => setQuery(event.target.value)}
                        placeholder={t("searchPlaceholder")}
                        aria-label={t("searchInputLabel")}
                        autoFocus
                    />
                    <Button
                        type="submit"
                        size="icon"
                        aria-label={t("searchSubmit")}
                    >
                        <ArrowRight />
                    </Button>
                </form>
            </PopoverContent>
        </Popover>
    );
}
